import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignStartHorizontal,
  AlignStartVertical,
} from "lucide-react";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_ALIGN_BOTTOM,
  TEMPLATES_ALIGN_CENTER,
  TEMPLATES_ALIGN_LAYERS,
  TEMPLATES_ALIGN_LEFT,
  TEMPLATES_ALIGN_MIDDLE,
  TEMPLATES_ALIGN_RIGHT,
  TEMPLATES_ALIGN_TOP,
} from "../../../i18n/keysTranslations";
import { BORDER_RADIUS_BUTTON } from "../../../utils/constants";
import { LAYER_ALIGN } from "./alignSelectedLayers";

const actions = [
  {
    align: LAYER_ALIGN.LEFT,
    labelKey: TEMPLATES_ALIGN_LEFT,
    Icon: AlignStartVertical,
  },
  {
    align: LAYER_ALIGN.TOP,
    labelKey: TEMPLATES_ALIGN_TOP,
    Icon: AlignStartHorizontal,
  },
  {
    align: LAYER_ALIGN.CENTER,
    labelKey: TEMPLATES_ALIGN_CENTER,
    Icon: AlignCenterVertical,
  },
  {
    align: LAYER_ALIGN.MIDDLE,
    labelKey: TEMPLATES_ALIGN_MIDDLE,
    Icon: AlignCenterHorizontal,
  },
  {
    align: LAYER_ALIGN.RIGHT,
    labelKey: TEMPLATES_ALIGN_RIGHT,
    Icon: AlignEndVertical,
  },
  {
    align: LAYER_ALIGN.BOTTOM,
    labelKey: TEMPLATES_ALIGN_BOTTOM,
    Icon: AlignEndHorizontal,
  },
];

const LayerAlignToolbar = ({ disabled = false, onAlign }) => {
  const { t } = useTranslationApp();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: "text.primary", fontSize: "13px" }}
      >
        {t(TEMPLATES_ALIGN_LAYERS)}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 0.75,
        }}
      >
        {actions.map(({ align, labelKey, Icon }) => (
          <Box
            key={align}
            component="button"
            type="button"
            disabled={disabled}
            aria-label={t(labelKey)}
            onClick={() => onAlign(align)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              minHeight: 36,
              px: 1,
              py: 0.75,
              border: "1px solid #E4E4E7",
              borderRadius: BORDER_RADIUS_BUTTON,
              bgcolor: "#fff",
              color: "text.primary",
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 500,
              textAlign: "center",
              appearance: "none",
              "&:hover": disabled
                ? undefined
                : { bgcolor: "action.hover" },
            }}
          >
            <Icon size={16} />
            {t(labelKey)}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LayerAlignToolbar;
